import React from "react";
import { FaFacebookSquare, FaTelegram } from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";
import { FaSquareXTwitter } from "react-icons/fa6";

function ShareSosmed() {
	const handleWhatsAppShare = () => {
		const url = window.location.href;
		const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(url)}`;
		window.open(whatsappUrl, "_blank");
	};

	const handleFacebookShare = () => {
		const url = window.location.href;
		const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
		window.open(facebookUrl, "_blank");
	};

	const handleTwitterShare = () => {
		const url = window.location.href;
		const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(url)}`;
		window.open(twitterUrl, "_blank");
	};

	const handleTelegramShare = () => {
		const url = window.location.href;
		const telegramUrl = `https://telegram.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(url)}`;
		window.open(telegramUrl, "_blank");
	};

	return (
		<div className="mt-8 pt-6 border-t border-gray-200">
			<div className="flex items-center gap-4">
				<span className="text-sm font-semibold text-gray-700">Share to :</span>
				<div className="flex items-center gap-2">
					<button
						onClick={handleWhatsAppShare}
						className="w-9 h-9 rounded-full bg-green-50 hover:bg-green-100 flex items-center justify-center text-green-600 hover:text-green-700 transition-all duration-200 hover:scale-110"
					>
						<RiWhatsappFill className="w-5 h-5" />
					</button>
					<button
						onClick={handleFacebookShare}
						className="w-9 h-9 rounded-full bg-blue-50 hover:bg-blue-100 flex items-center justify-center text-blue-600 hover:text-blue-700 transition-all duration-200 hover:scale-110"
					>
						<FaFacebookSquare className="w-5 h-5" />
					</button>
					<button
						onClick={handleTwitterShare}
						className="w-9 h-9 rounded-full bg-gray-50 hover:bg-gray-100 flex items-center justify-center text-gray-800 hover:text-gray-900 transition-all duration-200 hover:scale-110"
					>
						<FaSquareXTwitter className="w-5 h-5" />
					</button>
					<button
						onClick={handleTelegramShare}
						className="w-9 h-9 rounded-full bg-sky-50 hover:bg-sky-100 flex items-center justify-center text-sky-600 hover:text-sky-700 transition-all duration-200 hover:scale-110"
					>
						<FaTelegram className="w-5 h-5" />
					</button>
				</div>
			</div>
		</div>
	);
}

export default ShareSosmed;
